<article class="story-detail" *ngIf="story$ | async as story">
  <div class="container">
    <app-breadcrumbs class="d-block mb-3 mt-3" [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
  </div>

  <main class="section-inset-y">
    <div class="container publish-alert alert alert--info d-flex align-items-center mb-5" *ngIf="!story.publish">
      <div class="me-3">
        <app-icon anchor="icon-warning"></app-icon>
      </div>
      <span [innerHTML]="previewPlaceholder$ | async"></span>
    </div>
    <header class="story-detail__header container container-size-xs">
      <h1 class="text-secondary h2">{{ story.title }}</h1>
      <span *ngIf="story.initiative?.id">
        {{ 'verhaal-gekoppeld-initiatief-tekst' | fromDictionary }}
        <a class="fw-bold" [routerLink]="story.initiative?.url">{{ story.initiative?.title || story.initiative?.subtitle }}</a>
      </span>
      <nav class="meta-list d-flex justify-content-between mt-3 mb-5">
        <ul class="themes-list" *ngIf="story.themes?.length || story.locations?.length">
          <li *ngFor="let theme of story.themes; let i = index">
            <a [routerLink]="['/thema', theme.slug]" class="button button-icon button--primary">
              <app-icon class="icon-xs" [anchor]="theme.icon || 'icon-idea'" [attr.aria-label]="theme.title"></app-icon>
            </a>
          </li>
        </ul>
        <ul class="meta-list-secondary mb-3 mb-md-0 mt-md-3">
          <li class="me-3 meta-list-secondary__item">
            <a
              *ngIf="story.locations?.length === 1"
              class="d-inline-flex align-items-center"
              [href]="
                story.entireArea
                  ? 'https://www.google.com/maps/place/IJssel/@52.2733711,5.6986093'
                  : 'https://www.google.com/maps/search/' + story?.locations?.[0]?.lat + ',' + story.locations?.[0]?.lng
              "
              aria-label="bekijk locatie op google maps"
              target="_blank"
            >
              <span class="chip chip--muted">
                <app-icon anchor="icon-map-marker"></app-icon>
              </span>
              <span class="text-primary fw-bold ms-2">
                <ng-container *ngIf="!story.entireArea">
                  {{ story.locations?.[0]?.label || ('bekijk-op-kaart' | fromDictionary) }}
                </ng-container>
                <ng-container *ngIf="story.entireArea">{{ 'gehele-ijssel' | fromDictionary }}</ng-container>
              </span>
            </a>

            <a
              *ngIf="(story.locations?.length || 0) > 1"
              class="d-inline-flex align-items-center"
              [routerLink]="['.']"
              fragment="praktische-informatie"
            >
              <span class="chip chip--muted">
                <app-icon anchor="icon-map-marker"></app-icon>
              </span>
              <span class="text-primary fw-bold ms-2">{{ 'bekijk-locaties' | fromDictionary }}</span>
            </a>
          </li>

          <li class="d-inline-flex align-items-center meta-list-secondary__item meta-list-secondary__item--date" *ngIf="story.createdOn">
            <span class="chip chip--muted">
              <app-icon anchor="icon-calendar"></app-icon>
            </span>
            <span class="text-primary fw-bold ms-2">{{ story.createdOn | date : 'd MMM y' }}</span>
          </li>
        </ul>
      </nav>
    </header>
    <div class="container">
      <figure class="mb-md-6 d-block story-detail__figure" *ngIf="story.image && story.image.url">
        <div class="story-detail__figure__wrapper">
          <app-image
            [imageSizes]="[900, 1400, 1600, 1800]"
            [alt]="story.image.alt ?? story.title"
            [image]="story.image"
            [loading]="'eager'"
            [sizes]="{ xs: 12, md: 12, sm: 12 }"
            [objectFitMode]="true"
          ></app-image>
          <app-bg-wave [autoPlay]="false" [startPos]="'12s'" [bgColor]="'var(--bs-light)'" [strokeColor]="'transparent'"></app-bg-wave>
        </div>
        <figcaption *ngIf="story.image.caption" class="type-body-xs story-detail__figure__caption text-primary">
          &copy; {{ ('foto-credits-prefix' | fromDictionary) + story.image.caption }}
        </figcaption>
      </figure>
    </div>
    <section *ngIf="story.intro" class="container container-size-xs mb-4">
      <p class="lead fw-bold py-3 py-xl-4">{{ story.intro }}</p>
    </section>
    <!--<div
      class="markdown-content container container-size-xs"
      fstrDynamicContent
      [innerHTML]="story?.text || '' | resizeHtmlImages | stripEmbed : (cookiePreferences$ | async) ?? undefined | safe"
    ></div>-->

    <div class="container container-size-xs">
      <ngx-dynamic-hooks
        class="markdown-content"
        [options]="{ sanitize: false, updateOnPushOnly: true }"
        [content]="story.text || '' | resizeHtmlImages | stripEmbed : (cookiePreferences$ | async) ?? undefined"
        fstrDynamicContent
      ></ngx-dynamic-hooks>

      <ng-container *ngIf="story.author">
        <div *ngIf="story.author?.name" class="story-detail__author mt-3">
          <app-image
            *ngIf="story.author.image"
            [imageSizes]="[80, 120, 200]"
            [alt]="story.author.name || story.title"
            [image]="story.author.image"
            [sizes]="{ xs: 12, md: 12, sm: 12 }"
            [objectFitMode]="true"
          ></app-image>
          <div class="d-flex align-items-start flex-column">
            <span class="text-secondary fw-bold">{{ 'verhaal-auteur-tekst' | fromDictionary }}</span>
            <span class="text-primary fw-bold">{{ story.author.name }}</span>
            <app-icon anchor="icon-squiggle" class="author-squiggle"></app-icon>
          </div>
        </div>
      </ng-container>

      <app-content-meta-info
        *ngIf="story.locations?.length"
        [locations]="story.locations || []"
        [entireArea]="story.entireArea ?? false"
        class="d-block mt-4"
      ></app-content-meta-info>
    </div>
  </main>

  <!-- Verhaal liken/stemmen weggehaald na review 06-03-2023 -->
  <!-- <div class="section-inset-y" *ngIf="showVoting">
      <app-vote
        [title]="'story-stemmen-titel' | fromDictionary"
        [text]="'story-stemmen-tekst' | fromDictionary"
        [resultText]="'story-stemmen-resultaat-tekst' | fromDictionary"
        [voteCount]="story.likes.likes"
        [isVoted]="story.likes.liked"
        (vote)="like(story.id)"
      ></app-vote>
    </div> -->

  <div class="overflow-hidden section-outset-y" *ngIf="(relatedContent$ | async)?.length">
    <div class="container my-md-5" *ngIf="relatedContent$ | async as relatedContent">
      <app-related-content
        [title]="'gerelateerde-content-titel' | fromDictionary"
        [content]="relatedContent"
        *ngIf="relatedContent.length"
      ></app-related-content>
    </div>
  </div>

  <ng-container *ngIf="(relatedStories$ | async)?.length">
    <div class="initiative__related-stories overflow-hidden section-outset-y" *ngIf="relatedStories$ | async as stories">
      <div class="initiative__related-stories__wrapper container">
        <app-related-stories
          class=""
          [stories]="stories"
          [title]="
            story.initiative
              ? story.initiative.subtitle || story.initiative.title
              : ('verhalenpagina-gerelateerde-verhalen-zonder-initiatief-titel' | fromDictionary)
          "
          [subtitle]="
            story.initiative
              ? ('verhalenpagina-gerelateerde-verhalen-subtitel' | fromDictionary)
              : ('verhalenpagina-gerelateerde-verhalen-zonder-initiatief-subtitel' | fromDictionary)
          "
          *ngIf="stories.length"
        ></app-related-stories>
      </div>
    </div>
  </ng-container>

  <div class="overflow-hidden section-outset-y" *ngIf="(relatedInitiatives$ | async)?.length">
    <div class="container my-md-5" *ngIf="relatedInitiatives$ | async as relatedInitiatives">
      <app-related-initiatives [initiatives]="relatedInitiatives" *ngIf="relatedInitiatives.length"></app-related-initiatives>
    </div>
  </div>
</article>
